namespace $.$$ {

	const $shm_hitalama_map_widget_float_layout_hor_left_drop_inset = 5
	const $shm_hitalama_map_widget_float_layout_hor_right_drop_inset = 5

	type $shm_hitalama_map_widget_float_layout_hor_rect = {
		top: number
		left: number
		width: number
		height: number
	}

	export class $shm_hitalama_map_widget_float_layout_hor extends $.$shm_hitalama_map_widget_float_layout_hor {

		resize_relatives?: readonly $shm_hitalama_map_widget_float_layout_hor_rect[]
		
		@ $mol_action
		link( str:string ){
			return new $giper_baza_link(str)
		}

		toolbar_style_top(): string {
			return this.head_showed() ? '-40px' : '0'
		}

		@ $mol_action
		set_relatives() {
		}

		@ $mol_mem
		fit_to_widgets_auto() {
			return null
		}

		@ $mol_mem
		selected_for_candidates(): $giper_baza_link[] {
			const page = this.Map_page()
			const selected_links = page.selected_links()
			const this_link = this.widget().link_str()
			if( selected_links.find( l => l.str == this_link ) ) {
				return []
			}
			const ancestors = this.ancestor_links()
			return selected_links.filter( link => !ancestors.has( link.str ) )
		}

		ancestor_links() {
			const ancestors = new Set<string>()
			let parent = this.widget().container_widget()
			while( parent ) {
				if( ancestors.has( parent.link_str() ) ) break
				ancestors.add( parent.link_str() )
				parent = parent.container_widget()
			}
			return ancestors
		}

		widget_view() {
			const page = this.Map_page()
			return page.Widget( this.widget().link() ).Sub() as $shm_hitalama_map_widget_float
		}

		lines() {
			const page = this.Map_page()
			const container = this.widget_view()
			let lines = [ container.left() ]
			
			const widgets = this.widget().widgets()
			widgets.forEach( w => {
				const widget = page.Widget(w.link()).Sub()
				lines.push( lines.at(-1)!+widget.width() )
			} )

			lines.push( container.left() + container.width() )

			return lines
		}

		@ $mol_mem
		candidates_drag() {
			const page = this.Map_page()
			const selected_links = this.selected_for_candidates().sort( (l1,l2) => {
				const b1 = page.Widget( l1 ).Sub()
				const b2 = page.Widget( l2 ).Sub()
				return b1.left() - b2.left()
			} )
			if( !this.links_addable( selected_links.map( link => link.toString() ) ) ) {
				this.candidate_links( [] )
				return {}
			}
			if( selected_links.length == 0 ) {
				this.candidate_links( [] )
				return {}
			}
			const selected_dragged = selected_links.some( link => page.Widget( link ).Sub().dragged() )
			const has_preview = this.candidate_links().length > 0
			if( this.transforming() && !selected_dragged && !has_preview ) return

			const first = page.Widget( selected_links[0] ).Sub()
			const selected = selected_links.map( l => l.toString() )
			const selected_set = new Set( selected )
			const pos = this.find_pos( first, selected_set )
			const dragged = first.dragged()
			const best = pos >= 0 ? this.Map_page().layout_drop_best() : null
			if( pos >= 0 && best?.layout !== this.widget().link_str() ) {
				this.candidate_links( [] )
				const skip = new Set(
					selected_links
						.map( l => l.toString() )
						.filter( l => page.Widget( this.link( l ) ).Sub().dragged() )
				)
				this.move_widgets_to_places( this.links(), skip )
				return { pos, dragged, selected_links }
			}
			
			let candidate_links: $giper_baza_link[] = []
			this.candidate_pos( pos )
			if( dragged && (pos < 0) ) {
				const current = new Set( this.links() )
				const inner_links = selected_links.map( l => l.toString() ).filter( l => current.has( l ) )
				if( inner_links.length ) this.links_splice( -1, inner_links )
				else this.move_widgets_to_places()
			}
			if( !dragged ) {
				this.links_splice( pos, selected_links.map( l => l.toString() ) )
			}
			if( dragged && (pos >= 0) ) {
				candidate_links = selected_links
				const preview_links = my_splice( this.links(), pos, selected )
				this.move_widgets_to_places( preview_links, new Set( selected ) )
			}
			this.candidate_links( candidate_links )

			return { pos, dragged, selected_links }
		}

		find_pos(
			widget: $.$shm_hitalama_map_widget_float,
			skipped = new Set<string>(),
		) {
			return this.find_pos_result( widget, skipped )?.pos ?? -1
		}

		find_pos_result(
			widget: $.$shm_hitalama_map_widget_float,
			skipped = new Set<string>(),
		): { pos: number; distance: number } | null {
			const container = this.widget_view()

			const c_y = widget.top() + widget.height() / 2
			const widget_left = widget.left()
			const widget_right = widget_left + widget.width()

			const left = container.left()
			const right = left + container.width()
			const top = container.top()
			const bottom = top + container.height()
			
			if( c_y < top || c_y > bottom ) return null
			if(
				widget_right < left + $shm_hitalama_map_widget_float_layout_hor_left_drop_inset
				|| widget_left > right - $shm_hitalama_map_widget_float_layout_hor_right_drop_inset
			) return null

			const lines = this.insert_lines( skipped )
			let pos = 0
			let distance = Infinity

			for( let i = 0; i < lines.length; i++ ) {
				const next_distance = Math.abs( lines[i] - widget_left )
				if( next_distance < distance ) {
					pos = i
					distance = next_distance
				}
			}

			return { pos, distance }
		}

		drop_candidate() {
			const page = this.Map_page()
			const selected_links = this.selected_for_candidates().sort( (l1,l2) => {
				const b1 = page.Widget( l1 ).Sub()
				const b2 = page.Widget( l2 ).Sub()
				return b1.left() - b2.left()
			} )
			if( !this.links_addable( selected_links.map( link => link.toString() ) ) ) return null
			if( selected_links.length == 0 ) return null

			const first = page.Widget( selected_links[0] ).Sub()
			const selected_set = new Set( selected_links.map( l => l.toString() ) )
			const pos = this.find_pos_result( first, selected_set )
			if( !pos ) return null

			return {
				layout: this.widget().link_str(),
				pos: pos.pos,
				distance: pos.distance,
				depth: 0,
				z: 0,
			}
		}

		insert_lines( skipped = new Set<string>() ) {
			const page = this.Map_page()
			const lines = [ this.left() + this.padding_left() ]
			let left = lines[0]
			
			for( const link of this.links() ) {
				if( skipped.has( link ) ) continue

				const item = page.Widget( this.link( link ) ).Sub()
				left += item.width() + this.gap()
				lines.push( left )
			}

			return lines
		}

		auto_height_calc() {
			const page = this.Map_page()
			const links = this.links()
			let height = this.padding_top() + this.padding_bottom() + 100

			for( const link of links ) {
				const widget = page.Widget( this.link( link ) ).Sub()
				height = Math.max( height, widget.height() + this.padding_top() + this.padding_bottom() )
			}

			return height
		}

		@ $mol_mem
		includes() {
			const widgets = this.widget().widgets()
			return widgets.map( b => b.link_str() ).join(', ')
		}

		@ $mol_mem
		arrange() {
			if( this.transforming() ) return null

			const skip = new Set(
				this.selected_for_candidates()
					.map( l => l.toString() )
					.filter( l => this.Map_page().Widget( this.link( l ) ).Sub().dragged() )
			)
			this.move_widgets_to_places( this.links(), skip )

			return null
		}

		@ $mol_action
		links_splice( pos: number, links_changed: string[] ) {
			const prev = this.links()
			if( pos >= 0 ) {
				links_changed = links_changed.filter( link => prev.includes( link ) || this.link_addable( link ) )
				if( links_changed.length == 0 ) {
					this.move_widgets_to_places()
					return
				}
			}
			const next_links = my_splice( prev, pos, links_changed )
			if( next_links.join(',') == prev.join(',') ) {
				this.move_widgets_to_places()
				return
			}

			const links_added = pos == -1 ? [] : links_changed.filter( link => !prev.includes( link ) )
			this.links( next_links )
			const inside = pos == -1 ? null : this.widget()
			links_changed.forEach( l => {
				const w = this.map().widget(l)
				w.container_widget( inside )
			} )
			this.links_raise_added( links_added )
			this.move_widgets_to_places()
		}

		links_raise_added( links_added: string[] ) {
			for( const link of [ ...links_added ].reverse() ) {
				this.link_raise_above_layout( link )
			}
		}

		link_raise_above_layout( link: string ) {
			const list = this.map().Widgets_list(null)
			const widgets = ( list?.remote_list() ?? [] ) as $shm_hitalama_map_widget[]
			const layout_link = this.widget().link_str()
			const layout_index = widgets.findIndex( widget => widget.link_str() === layout_link )
			const widget_index = widgets.findIndex( widget => widget.link_str() === link )
			if( layout_index < 0 || widget_index < 0 ) return
			if( widget_index > layout_index ) return

			const widget = this.map().widget( link )
			const block_links = new Set( widget.z_block().map( ( widget: $shm_hitalama_map_widget ) => widget.link_str() ) )
			if( block_links.has( layout_link ) ) return

			const block = widgets.filter( ( widget: $shm_hitalama_map_widget ) => block_links.has( widget.link_str() ) )
			const next_widgets = widgets.filter( ( widget: $shm_hitalama_map_widget ) => !block_links.has( widget.link_str() ) )
			const next_layout_index = next_widgets.findIndex( ( widget: $shm_hitalama_map_widget ) => widget.link_str() === layout_link )
			if( next_layout_index < 0 ) return

			next_widgets.splice( next_layout_index + 1, 0, ...block )
			list?.remote_list( next_widgets as any )
		}

		link_addable( link: string ) {
			const add_types = this.add_types()
			if( add_types.length == 0 ) return true

			const widget = this.map().widget( link )
			return add_types.includes( widget.type() )
		}

		links_addable( links: string[] ) {
			const current = new Set( this.links() )
			return links.every( link => current.has( link ) || this.link_addable( link ) )
		}

		@ $mol_action
		move_widgets_to_places(
			links = this.links(),
			skip = new Set<string>(),
		) {
			let left = this.left() + this.padding_left()
			const top = this.top() + this.padding_top()
			const height = this.height() - this.padding_top() - this.padding_bottom()

			const page = this.Map_page()
			for (let i = 0; i < links.length; i++) {
				const id = links[i]
				const widget = page.Widget( this.link(id) ).Sub()!

				if( !skip.has( id ) ) {
					widget.top( top )
					widget.left( left )
					widget.height( height )
					try {
						widget.Contextmenu().to_front()
					} catch (error) {
						console.error(error)
					}
				}
				left += widget.width() + this.gap()
			}
		}

		calc_relative_rects() {
			const widgets = this.widget().widgets()
			const page = this.Map_page()
			const left = this.left() + this.padding_left()

			return widgets.map( w => {
				const widget = page.Widget( w.link() ).Sub()!
				return {
					top: widget.top() - this.top(),
					left: widget.left() - left,
					width: widget.width(),
					height: widget.height(),
				}
			} )
		}

		resize_widgets( relatives = this.resize_relatives ) {
			if( !relatives ) return

			const top = this.top() + this.padding_top()
			const left = this.left() + this.padding_left()
			const height = this.height() - this.padding_top() - this.padding_bottom()
			const widgets = this.widget().widgets()
			const page = this.Map_page()

			for( let i = 0; i < widgets.length; i++ ) {
				const w = widgets[i]
				const widget = page.Widget( w.link() ).Sub()!
				const rect = relatives[i]
				if( !rect ) continue

				widget.top( top )
				widget.left( left + rect.left )
				widget.height( height )
			}
		}

		links( next?: string[] ) {
			if( next === undefined ) return this.widget().widgets().map( b => b.link().str ) ?? []
			this.widget().widgets( next.map( l => this.Map_page().widget_by_link( new $giper_baza_link( l ) ) ) )
			return next
		}

		@ $mol_action
		push_widget( ref: $giper_baza_link ) {
			const page = this.Map_page()
			this.widget().widgets( [ ...this.widget().widgets(), page.widget_by_link(ref) ] )
			this.move_widgets_to_places()
		}

		@ $mol_mem
		new_pos_visible() {
			return this.candidate_links().length > 0 ? super.new_pos_visible() : []
		}

		new_pos_width_px(): string {
			const ref = this.candidate_links()?.[0]
			if( !ref ) return '0px'

			const page = this.Map_page()
			const b = page.Widget( ref ).Sub()
			return (b?.width()??0)+'px'
		}
		new_pos_left(): number {
			const page = this.Map_page()

			const pos = this.candidate_pos()
			if( pos < 0 ) return 0

			const candidate_links = this.candidate_links().map( l => l.toString() )
			const candidate_set = new Set( candidate_links )
			const preview_links = my_splice( this.links(), pos, candidate_links )
			const preview_pos = preview_links.findIndex( l => candidate_set.has( l ) )
			if( preview_pos < 0 ) return 0

			let left = this.padding_left()
			for( let i = 0; i < preview_pos; i++ ) {
				const widget = page.Widget( this.link( preview_links[i] ) ).Sub()
				left += widget.width() + this.gap()
			}
			return left
		}

		new_pos_left_px(): string {
			return this.new_pos_left()+'px'
		}
		
		contextmenu_widget_add( type: string ) {
			if( this.add_types().length > 0 && !this.add_types().includes( type ) ) return null

			this.Add_to_container_menu().contextmenu_showed( false )
			const w = (this.Add_to_container_menu().presets() as any)[ type ]( this.Add_to_container_menu().add_pos() ) as $shm_hitalama_map_widget
			const widget = this.Map_page().Widget( w.link() ).Sub() as $shm_hitalama_map_widget_float
			const pos = this.find_pos( widget )
			this.links_splice( pos == -1 ? this.links().length : pos, [ w.link_str() ] )
			return widget
		}

		Add_to_container_menu(): $.$shm_hitalama_map_page_contextmenu {
			const obj = super.Add_to_container_menu() as $.$shm_hitalama_map_page_contextmenu & {
				add_types_limited?: boolean
			}
			if( obj.add_types_limited ) return obj

			const item_ids = obj.item_ids.bind( obj )
			const item_ids_top = obj.item_ids_top.bind( obj )
			const item_ids_top2 = obj.item_ids_top2.bind( obj )
			obj.item_ids = ()=> this.add_types().length > 0 ? this.add_types() : item_ids()
			obj.item_ids_top = ()=> this.add_types().length > 0 ? [] : item_ids_top()
			obj.item_ids_top2 = ()=> this.add_types().length > 0 ? [] : item_ids_top2()
			obj.add_types_limited = true
			return obj
		}

		items_label() {
			return 'Элементы ('+(this.widget().widgets()?.length??0)+')'
		}

		items() {
			return this.widget().widgets().map( b => this.Item( b.link_str() ) )
		}

		item_title( id: any ): string {
			return id
		}
		
	}

	function my_splice( arr: string[], pos: number, items: string[] ) {
		const result = [ ...arr ]

		items.forEach( item => {
			const existingIndex = result.indexOf( item )
			if( existingIndex !== -1 ) {
				result.splice( existingIndex, 1 )
			}
		} )

		if( pos >= 0 ) {
			result.splice( pos, 0, ...items )
		}

		return result
	}

}
